// extracted by mini-css-extract-plugin
module.exports = {"main":"Input_main__FrxwY"};